import React, { Component } from 'react'
import styled from 'styled-components'
import { Flex } from 'reflexbox'
import { Link } from 'react-router-dom'
import { Routes } from '../../navigation/routes'
import colors from '../../config/colors'

const HeaderContainer = styled(Flex)`

    background-color: ${colors.DarkBlue};
    color: ${colors.White};
    justify-content: center;

    position: relative;
    z-index: 1;
    -webkit-box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.4);
    -moz-box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.4);
    box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.4);
  `;

const HeaderWrapper = styled(Flex)`
    flex-shrink: 0;
    align-items: center; 
    padding: 1em;
    justify-content: space-between;
    margin: auto;
    max-width: 1400px;
    width: 100%;
`;
const HeaderButtons = styled(Flex)`
    align-items: baseline;
`;

const HeaderButton = styled(Link)`
    font-size: 1rem;
    margin: 0px 10px;
    cursor: pointer;
    color: inherit;
    text-decoration: inherit;  

`;

interface HeaderIProps {

}

interface HeaderIState {

}

export default class Header extends Component<HeaderIProps, HeaderIState>{

    render() {
        return <HeaderContainer>
            <HeaderWrapper>
                <HeaderButton to={Routes.Homepage}>
                    <img src='/assets/imgs/TTLogo.svg' alt='Trivia Togehter' />
                </HeaderButton>
                <HeaderButtons>
                    <HeaderButton to={Routes.TermsAndConditions}>Terms and Conditions</HeaderButton>
                    <HeaderButton to={Routes.PrivacyPolicy}>Privacy Policy</HeaderButton>
                </HeaderButtons>
            </HeaderWrapper>
        </HeaderContainer>
    }
}
